import { h, ref } from 'vue';
import { NotifyPlugin, Button, Badge } from 'tdesign-vue-next';
import { v4 as uuidv4 } from 'uuid';
import { HttpRequest } from '@/service/createAxios';
import { useEnv } from '@/utils/env';
const env = useEnv();

export enum MsgType {
  ERROR = 'error',
  WARNING = 'warning',
}

export type ResponseErrorMsg = {
  title: string;
  content?: string;
  msgType: MsgType;
  isMerge: boolean; // 是否合并弹窗
};

export type ResponseErrorCollectParam = {
  checkId: string;
  errorList: Array<{ title: string; content?: string }>;
};

const RESPONSE_ERROR_MESSAGE_ID = 'response-error-message-id'; // 网络错误弹窗节点唯一id
const RESPONSE_NO_PERMISSION_MESSAGE_ID = 'response-no-premission-message-id'; // 网络没有权限弹窗节点唯一id
const responseMessageErrorRef = ref(); // 网络错误弹窗实例
const responseMessageNoPermissionRef = ref(); // 网络没有权限弹窗实例
let globalCheckId = '';
let responseMessageErrorList: Array<ResponseErrorMsg> = []; // 收集请求响应错误信息
let responseMessageNoPermissionList: Array<ResponseErrorMsg> = []; // 收集请求没有权限信息
// 忽略的错误信息
const ignoreErrorMessageList = [/AxiosError: timeout of \d+ms exceeded/, /AxiosError: Network Error/];

// 展示网络错误信息弹窗的方法
export function showUniqueDialog(msg: ResponseErrorMsg) {
  // 忽略一些错误信息，不展示网络错误弹窗，仅在现网生效
  const isProdOrExp = env.isProduction;
  const isIgnoreMsg =
    isProdOrExp && ignoreErrorMessageList.some((ignoreRule) => msg?.content && ignoreRule.test(msg.content));
  if (isIgnoreMsg) {
    console.error('ignore error message: ', msg);
    return;
  }
  if (msg.isMerge) {
    let $uniqueDialogNode: any;
    let $badgeNode: any;
    const isErrorType = msg.msgType === MsgType.ERROR;
    const notificationMethod = isErrorType ? 'error' : 'warning';
    if (isErrorType) {
      responseMessageErrorList.push(msg);
      $uniqueDialogNode = document.getElementById(RESPONSE_ERROR_MESSAGE_ID);
      $badgeNode = $uniqueDialogNode?.querySelector('.t-badge--circle');
    } else {
      responseMessageNoPermissionList.push(msg);
      $uniqueDialogNode = document.getElementById(RESPONSE_NO_PERMISSION_MESSAGE_ID);
      $badgeNode = $uniqueDialogNode?.querySelector('.t-badge--circle');
    }

    if ($uniqueDialogNode && $badgeNode) {
      // 判读全局是否有响应错误信息通知
      const lenStr = isErrorType
        ? responseMessageErrorList.length.toString()
        : responseMessageNoPermissionList.length.toString(); // 修改错误信息数量 徽标
      $badgeNode.innerHTML = lenStr;
    } else {
      if (isErrorType) {
        globalCheckId = uuidv4();
        responseMessageErrorList = [];
        responseMessageErrorList.push(msg);
      } else {
        responseMessageNoPermissionList = [];
        responseMessageNoPermissionList.push(msg);
      }
      const notitfyInstance = NotifyPlugin[notificationMethod]({
        duration: 0,
        title: msg.title,
        content: (): any =>
          h(
            'div',
            {},
            isErrorType
              ? [h('div', { class: 'text-gray-secondary' }, `(${globalCheckId})`), h('div', {}, msg.content)]
              : [h('div', { innerHTML: msg.content })],
          ) as any,
        footer: (): any =>
          h(
            'div',
            {
              slot: 'footer',
              class: 't-notification__detail pr-[20px]',
              id: isErrorType ? RESPONSE_ERROR_MESSAGE_ID : RESPONSE_NO_PERMISSION_MESSAGE_ID,
            },
            h(
              Badge,
              { count: isErrorType ? responseMessageErrorList.length : responseMessageNoPermissionList.length },
              h(
                Button,
                {
                  theme: 'primary',
                  onClick: () => {
                    if (isErrorType) {
                      NotifyPlugin.close(responseMessageErrorRef.value);
                      const collectErrorList = responseMessageErrorList.map((item) => {
                        const temp = {
                          title: item.title,
                          content: item?.content ?? '',
                        };
                        return temp;
                      });
                      // 前端打印网络错误
                      console.group('开始打印网络错误');
                      collectErrorList.forEach((item) => {
                        console.error(`checkId: ${globalCheckId}`, item);
                      });
                      console.groupEnd();
                      // 上传网络错误信息
                      const param: ResponseErrorCollectParam = {
                        checkId: globalCheckId,
                        errorList: collectErrorList,
                      };
                      responseErrorCollectService(param);
                    } else {
                      NotifyPlugin.close(responseMessageNoPermissionRef.value);
                    }
                  },
                },
                'Close',
              ),
            ),
          ) as any,
        onCloseBtnClick: () => {
          if (isErrorType) {
            globalCheckId = '';
            responseMessageErrorList = [];
          } else {
            responseMessageNoPermissionList = [];
          }
        }, // 重置收集的
      });
      isErrorType
        ? (responseMessageErrorRef.value = notitfyInstance)
        : (responseMessageNoPermissionRef.value = notitfyInstance);
    }
  } else {
    NotifyPlugin[msg.msgType]({
      title: msg.title,
      content: msg.content,
    });
  }
}

// 上传网络错误信息
async function responseErrorCollectService(param: ResponseErrorCollectParam) {
  const httpReq = new HttpRequest(
    {
      baseURL: '/',
      timeout: 60000, // 60s
      headers: {},
      params: {},
      withCredentials: true,
      responseType: 'json',
    },
    {
      isUseResponse: false,
    },
  ).createInstance();
  return await httpReq.post('/api/response_error_collect', param);
}
